(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/row.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/row.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Row = Marionette.View.extend({
    tagName: 'ul',
    ui: {
      clearRowButton: '.maltipset-clear-row-btn'
    },
    events: {
      'click .btn-bet-maltipset': 'matchClicked',
      'click @ui.clearRowButton': 'clearRow'
    },
    className: function() {
      var className = 'js-slider-slide slider-slide maltipset-board-row',
        coupon = svs.maltipset.collections.coupons.getCurrentCoupon();

      if (coupon.isEnabled()) {
        if (this.model.get('rowNo') === 1) {
          className += ' maltipset-row-active';
        }
        if (this.model.get('numberOfSelectedMatches')) {
          className += ' maltipset-row-enabled';
        }
        if (this.model.isMaxNoOfMatchesSelected()) {
          className += ' maltipset-row-complete';
        }
      }

      if (coupon.isMOrRSystem()) {
        className += ' maltipset-system-active';
      }

      return className;
    },
    modelEvents: {
      unMarkAll: 'unMarkAllBtns',
      'change:numberOfSelectedMatches': 'numMarkedMatchesChanged',
      'change:completeRow change:numberOfSelectedMatches change:active':
        'render'
    },

    template: function(data) {
      return svs.maltipset.templates.row(data);
    },

    templateContext: function() {
      return {
        showClearRowButton:
          this.model.get('active') && this.model.get('hasSelectedMatches')
      };
    },

    initialize: function() {
      this.$el.attr('data-rowNum', this.model.get('rowNo'));
    },
    clearRow: function() {
      var self = this;
      var dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Vill du rensa din rad?',
        actions: [
          {
            title: 'Avbryt'
          },
          {
            title: 'Fortsätt',
            callback: function() {
              dialog.close();
              svs.maltipset.collections.coupons.getCurrentCoupon().removeXpert();
              self.model.unMarkAll();
            }
          }
        ]
      });
      svs.components.dialog.api.add(dialog);
    },
    unMarkAllBtns: function() {
      this.$el
        .find('.btn-bet-maltipset-selected')
        .removeClass('btn-bet-maltipset-selected');
    },
    matchClicked: function(event) {
      var self = this;
      var button = $(event.currentTarget);
      var selected = button.hasClass('btn-bet-maltipset-selected');

      if (
        (!this.model.isMaxNoOfMatchesSelected() || selected) &&
        this.model.collection.currentRowIndex === this.model.get('rowNo') - 1 &&
        svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
      ) {
        if (selected) {
          button.removeClass('btn-bet-maltipset-selected');
        } else {
          button.addClass('btn-bet-maltipset-selected');
        }
        _.defer(function() {
          var index = button.data('index');
          self.model.markIndex(index, !selected);
        });
      }
    },
    numMarkedMatchesChanged: function() {
      this.$el.toggleClass(
        'maltipset-row-enabled',
        this.model.get('numberOfSelectedMatches') > 0
      );
      this.$el.toggleClass(
        'maltipset-row-complete',
        this.model.isMaxNoOfMatchesSelected()
      );
    },
    onBeforeRender: function() {
      this.$el.data('rowNo', this.model.get('rowNo'));
    }
  });
})(Backbone, _, svs);


 })(window);